import { SettingRow } from '@affine/component/setting-components';
import { useI18n } from '@affine/i18n';

import { PaymentMethodUpdater as PaymentMethodButton } from './payment-method-updater';
import * as styles from './styles.css';

export const PaymentMethodUpdater = () => {
  const t = useI18n();
  return (
    <SettingRow
      className={styles.paymentMethod}
      name={t['com.streamlain.payment.billing-setting.payment-method']()}
      desc={t[
        'com.streamlain.payment.billing-setting.payment-method.description'
      ]()}
    >
      <PaymentMethodButton />
    </SettingRow>
  );
};
